import { render, staticRenderFns } from "./AccessibilityTextHelper.vue?vue&type=template&id=6ffeced9&scoped=true&"
import script from "./AccessibilityTextHelper.vue?vue&type=script&lang=js&"
export * from "./AccessibilityTextHelper.vue?vue&type=script&lang=js&"
import style0 from "./AccessibilityTextHelper.vue?vue&type=style&index=0&id=6ffeced9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffeced9",
  null
  
)

export default component.exports